import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackAnalyticsEvent } from "./analytics";
import { captureCampaignData } from "./campaignTracker";

const AnalyticsTracker = () => {
  const location = useLocation();
  useEffect(() => {
    captureCampaignData(location.search);
    const screenName = location.pathname;
    trackAnalyticsEvent.screenView(screenName);
  }, [location]);
  return null;
};

export default AnalyticsTracker;
